import PrivateRoutes from 'routes/PrivateRoutes';

import SelfSchedulingContextProvider from 'lib/context/SelfSchedulingContext/SelfSchedulingContextProvider';
import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import CHECK_IN from './checkin';

const Documentation = withLazyFallback(() => import('components/Documentation/Documentation'));
const Mobile = withLazyFallback(() => import('components/Kiosk/Mobile'));
const KioskActivate = withLazyFallback(() => import('components/Kiosk/views/Activate'));
const KioskIdle = withLazyFallback(() => import('components/Kiosk/views/Idle'));
const KioskPhone = withLazyFallback(() => import('components/Kiosk/views/Phone'));
const RegisterPatient = withLazyFallback(() => import('components/Kiosk/views/RegisterPatient'));
const Login = withLazyFallback(() => import('components/admin/components/Login/Login'));
const MFADescription = withLazyFallback(() => import('components/MFADescription'));
const NotFound = withLazyFallback(() => import('components/NotFound'));
const SelfSchedulingV2 = withLazyFallback(
  () => import('components/Patient/SelfSchedulingV2/SelfSchedulingV2')
);
const Terms = withLazyFallback(() => import('components/Terms'));
const IconsPage = withLazyFallback(() => import('components/admin/pages/IconsPage/IconsPage'));
const PreferredLocation = withLazyFallback(
  () => import('components/admin/pages/Practices/forms/PreferredLocation')
);
const RWTPlan = withLazyFallback(() => import('components/public/RWTPlan/RWTPlan'));
const NewContactContainer = withLazyFallback(
  () => import('components/shared/contact/contact_container')
);

const PUBLIC = [
  {
    path: '',
    element: <PrivateRoutes type="private" />,
    children: [
      {
        path: '/',
        element: <Login loginType="user" />
      }
    ]
  },
  { path: 'rwt-plan', element: <RWTPlan /> },
  { path: 'mfa-description', element: <MFADescription /> },
  { path: 'documentation', element: <Documentation /> }, // TODO: @rasim this is not public, check it.
  { path: 'icons', element: <IconsPage /> },
  { path: 'contact', element: <NewContactContainer /> },
  { path: 'privacy', element: <Terms /> },
  {
    path: 'mobile',
    element: <Mobile />,
    children: [
      { path: 'idle', element: <KioskIdle /> },
      { path: 'phone', element: <KioskPhone /> },
      { path: 'activate', element: <KioskActivate /> },
      { path: 'register', element: <RegisterPatient /> },
      {
        path: 'schedule-appointment',
        element: (
          <SelfSchedulingContextProvider>
            <SelfSchedulingV2 />
          </SelfSchedulingContextProvider>
        )
      },
      ...CHECK_IN,
      { path: '*', element: <NotFound portal="kiosk" /> }
    ]
  },
  { path: 'select-practice', element: <PreferredLocation /> },
  { path: '*', element: <NotFound /> }
];

export default PUBLIC;
